import React, { useState } from "react"
import { linkResolver } from "../utils/linkResolver"
import { RichText } from "prismic-reactjs"
import { useStaticQuery, graphql } from "gatsby"
import X from "./svg/X"

const Banner = ({ content, isActive, isOpen, setIsOpen, close }) => {
  return (
    <div className="">
      {isOpen && (
        <div className="sticky top-0 z-30 p-1 bg-white w-screen px-3 mx-auto text-blue flex items-center">

          {isActive && (
            <div className="font-medium text-center bannerText pb-1 ml-auto">
              <RichText render={content} linkResolver={linkResolver} />
            </div>
            
          )}
          <button onClick={() => close(false)} className="ml-auto" aria-label="Close Banner">
            <X />
          </button>
        </div>
      )}
    </div>
  )
}

export default function Banners({close, isBannerOpen}) {
  const data = useStaticQuery(graphql`
    query Bannersquery {
      prismicHomepageBodyBanner {
        items {
          isactive
          content {
            raw
          }
        }
      }
    }
  `)

  const [isOpen, setIsOpen] = useState(true)
  return (
    <>
    { isBannerOpen ? 
    <>
      {data.prismicHomepageBodyBanner.items.map(({ content, isactive }, index) => (
        <Banner
          key={index}
          content={content.raw}
          isActive={isactive}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          close={close}
        />
      ))}
      </>
: null
    }
    </>
  )
}
